import iyfaaoPrice from "./pricelist";
import iswcCashPrize from "./iswccashprize";

const iyfaoGroupCat = {
    "Writing Groups" :{
        "Poem - any topic and style [i.e. sonnets, odes, etc.]" : {
            1:{
                "id":1,"number":"PW1", "name":"Junior Primary", "des":"Age 9 or below",  "price":iyfaaoPrice["PW1"], "cashprize":iswcCashPrize["PW1"]
                },
                2:{
                "id":2,"number":"PW2", "name":"Senior Primary", "des":"Age 9 to 12", "price":iyfaaoPrice["PW2"], "cashprize":iswcCashPrize["PW2"]
                },
                3:{
                "id":3,"number":"PW3", "name":"Junior Secondary", "des":"Age 12 to 15","price":iyfaaoPrice["PW3"], "cashprize":iswcCashPrize["PW3"]
                },
                4:{
                "id":4,"number":"PW4", "name":"Senior Secondary","des":"Age 15 to 17", "price":iyfaaoPrice["PW4"], "cashprize":iswcCashPrize["PW4"]
                },
                5:{
                "id":5,"number":"PW5", "name":"Open","des":"Age 18 or above", "price":iyfaaoPrice["PW5"], "cashprize":iswcCashPrize["PW5"]
                },
        },  
          "Short Story - any topic" : {
            1:{
                "id":1,"number":"SS1", "name":"Junior Primary", "des":"Age 9 or below, within 350 words",  "price":iyfaaoPrice["SS1"], "cashprize":iswcCashPrize["SS1"]
                },
                2:{
                "id":2,"number":"SS2", "name":"Senior Primary", "des":"Age 9 to 12, within 500 words", "price":iyfaaoPrice["SS2"], "cashprize":iswcCashPrize["SS2"]
                },
                3:{
                "id":3,"number":"SS3", "name":"Junior Secondary", "des":"Age 12 to 15, within 1000 words","price":iyfaaoPrice["SS3"], "cashprize":iswcCashPrize["SS3"]
                },
                4:{
                "id":4,"number":"SS4", "name":"Senior Secondary","des":"Age 15 to 17, within 1500 words", "price":iyfaaoPrice["SS4"], "cashprize":iswcCashPrize["SS4"]
                },
                5:{
                "id":5,"number":"SS5", "name":"Open","des":"Age 18 or above, within 3000 words", "price":iyfaaoPrice["SS5"], "cashprize":iswcCashPrize["SS5"]
                },
        },  
         "Persuasive Writing - any topic" : {
            1:{
                "id":1,"number":"PV1", "name":"Junior Primary", "des":"Age 9 or below, within 350 words",  "price":iyfaaoPrice["PV1"], "cashprize":iswcCashPrize["PV1"]
                },
                2:{
                "id":2,"number":"PV2", "name":"Senior Primary", "des":"Age 9 to 12, within 500 words", "price":iyfaaoPrice["PV2"], "cashprize":iswcCashPrize["PV2"]
                },
                3:{
                "id":3,"number":"PV3", "name":"Junior Secondary", "des":"Age 12 to 15, within 1000 words","price":iyfaaoPrice["PV3"], "cashprize":iswcCashPrize["PV3"]
                },
                4:{
                "id":4,"number":"PV4", "name":"Senior Secondary","des":"Age 15 to 17, within 1500 words", "price":iyfaaoPrice["PV4"], "cashprize":iswcCashPrize["PV4"]
                },
                5:{
                "id":5,"number":"PV5", "name":"Open","des":"Age 18 or above, within 3000 words", "price":iyfaaoPrice["PV5"], "cashprize":iswcCashPrize["PV5"]
                },
        },  
          "Drama Script - any topic" : {
            1:{
                "id":1,"number":"DS1", "name":"Junior Primary", "des":"Age 9 or below",  "price":iyfaaoPrice["DS1"], "cashprize":iswcCashPrize["DS1"]
                },
                2:{
                "id":2,"number":"DS2", "name":"Senior Primary", "des":"Age 9 to 12", "price":iyfaaoPrice["DS2"], "cashprize":iswcCashPrize["DS2"]
                },
                3:{
                "id":3,"number":"DS3", "name":"Junior Secondary", "des":"Age 12 to 15","price":iyfaaoPrice["DS3"], "cashprize":iswcCashPrize["DS3"]
                },
                4:{
                "id":4,"number":"DS4", "name":"Senior Secondary","des":"Age 15 to 17", "price":iyfaaoPrice["DS4"], "cashprize":iswcCashPrize["DS4"]
                },
                5:{
                "id":5,"number":"DS5", "name":"Open","des":"Age 18 or above", "price":iyfaaoPrice["DS5"], "cashprize":iswcCashPrize["DS5"]
                },
        },  
    },
    "Speech Groups" :{
        "Poem - any topic and style [i.e. sonnets, odes, etc.]" : {
            1:{
                "id":1,"number":"PS1", "name":"Junior Primary", "des":"Age 8 or below; under 3 minutes",  "price":iyfaaoPrice["PS1"], "cashprize":iswcCashPrize["PS1"]
                },
                2:{
                "id":2,"number":"PS2", "name":"Senior Primary", "des":"Age 9 to 11; under 4 minutes", "price":iyfaaoPrice["PS2"], "cashprize":iswcCashPrize["PS2"]
                },
                3:{
                "id":3,"number":"PS3", "name":"Junior Secondary", "des":"Age 12 to 14; under 5 minutes","price":iyfaaoPrice["PS3"], "cashprize":iswcCashPrize["PS3"]
                },
                4:{
                "id":4,"number":"PS4", "name":"Senior Secondary","des":"Age 15 to 17; under 6 minutes", "price":iyfaaoPrice["PS4"], "cashprize":iswcCashPrize["PS4"]
                },
                5:{
                "id":5,"number":"PS5", "name":"Open","des":"Age 18 or above; under 6 minutes", "price":iyfaaoPrice["PS5"], "cashprize":iswcCashPrize["PS5"]
                },
        },  
        "Prose - any topic and style [i.e. bible excerpt, article, etc.] " : {
            1:{
                "id":1,"number":"RS1", "name":"Junior Primary", "des":"Age 9 or below; under 3 minutes",  "price":iyfaaoPrice["RS1"], "cashprize":iswcCashPrize["RS1"]
                },
                2:{
                "id":2,"number":"RS2", "name":"Senior Primary", "des":"Age 9 to 12; under 4 minutes", "price":iyfaaoPrice["RS2"], "cashprize":iswcCashPrize["RS2"]
                },
                3:{
                "id":3,"number":"RS3", "name":"Junior Secondary", "des":"Age 12 to 15; under 5 minutes","price":iyfaaoPrice["RS3"], "cashprize":iswcCashPrize["RS3"]
                },
                4:{
                "id":4,"number":"RS4", "name":"Senior Secondary","des":"Age 15 to 17; under 6 minutes", "price":iyfaaoPrice["RS4"], "cashprize":iswcCashPrize["RS4"]
                },
                5:{
                "id":5,"number":"RS5", "name":"Open","des":"Age 18 or above; under 6 minutes", "price":iyfaaoPrice["RS5"], "cashprize":iswcCashPrize["SS5"]
                },
        },  
         "Public Speaking - any topic" : {
            1:{
                "id":1,"number":"BC1", "name":"Junior Primary", "des":"Age 9 or below; under 10 minutes",  "price":iyfaaoPrice["BC1"], "cashprize":iswcCashPrize["BC1"]
                },
                2:{
                "id":2,"number":"BC2", "name":"Senior Primary", "des":"Age 9 to 12; under 10 minutes", "price":iyfaaoPrice["BC2"], "cashprize":iswcCashPrize["BC2"]
                },
                3:{
                "id":3,"number":"BC3", "name":"Junior Secondary", "des":"Age 12 to 15; under 15 minutes","price":iyfaaoPrice["BC3"], "cashprize":iswcCashPrize["BC3"]
                },
                4:{
                "id":4,"number":"BC4", "name":"Senior Secondary","des":"Age 15 to 17; under 15 minutes", "price":iyfaaoPrice["BC4"], "cashprize":iswcCashPrize["BC4"]
                },
                5:{
                "id":5,"number":"BC5", "name":"Open","des":"Age 18 or above; under 20 minutes", "price":iyfaaoPrice["BC5"], "cashprize":iswcCashPrize["BC5"]
                },
        },  
          "Story Telling - any topic" : {
            1:{
                "id":1,"number":"TT1", "name":"Junior Primary", "des":"Age 9 or below; under 3 minutes",  "price":iyfaaoPrice["TT1"], "cashprize":iswcCashPrize["TT1"]
                },
                2:{
                "id":2,"number":"TT2", "name":"Senior Primary", "des":"Age 9 to 12; under 4 minutes", "price":iyfaaoPrice["TT2"], "cashprize":iswcCashPrize["TT2"]
                },
                3:{
                "id":3,"number":"TT3", "name":"Junior Secondary", "des":"Age 12 to 15; under 5 minutes","price":iyfaaoPrice["TT3"], "cashprize":iswcCashPrize["TT3"]
                },
                4:{
                "id":4,"number":"TT4", "name":"Senior Secondary","des":"Age 15 to 17; under 6 minutes", "price":iyfaaoPrice["TT4"], "cashprize":iswcCashPrize["TT4"]
                },
                5:{
                "id":5,"number":"TT5", "name":"Open","des":"Age 18 or above; under 6 minutes", "price":iyfaaoPrice["TT5"], "cashprize":iswcCashPrize["TT5"]
                },
        },  

        "Dramatic Performance - any topic and number of actors" : {
            1:{
                "id":1,"number":"DP1", "name":"Junior Primary", "des":"Age 9 or below; under 3 minutes",  "price":iyfaaoPrice["DP1"], "cashprize":iswcCashPrize["DP1"]
                },
                2:{
                "id":2,"number":"DP2", "name":"Senior Primary", "des":"Age 9 to 12; under 4 minutes", "price":iyfaaoPrice["DP2"], "cashprize":iswcCashPrize["DP2"]
                },
                3:{
                "id":3,"number":"DP3", "name":"Junior Secondary", "des":"Age 12 to 15; under 5 minutes","price":iyfaaoPrice["DP3"], "cashprize":iswcCashPrize["DP3"]
                },
                4:{
                "id":4,"number":"DP4", "name":"Senior Secondary","des":"Age 15 to 17; under 6 minutes", "price":iyfaaoPrice["DP4"], "cashprize":iswcCashPrize["DP4"]
                },
                5:{
                "id":5,"number":"DP5", "name":"Open","des":"Age 18 or above; under 6 minutes", "price":iyfaaoPrice["DP5"], "cashprize":iswcCashPrize["DP5"]
                },
        },  
    },

 
}

export default iyfaoGroupCat;